import React from "react"
import Wrapper from "@components/Wrapper"
import WrapperInner from "@components/WrapperInner"
import styles from "./Intro.module.scss"
import PlayStoreBadge from "./google-play-badge.png";
import AppStoreBadge from "./app-store-badge.png";
import { Link } from "gatsby"
import { OutboundLink } from "@assertiv/assertiv-gatsby-plugin-google-gtag";

const Intro = props => {
  return (
    <section className="bg-xl-light-gray">
      <Wrapper gap="outer" className="bg-white">
        <WrapperInner
          className={styles.wrapperInner + " row proxima-nova--light fs-18pt ml-0 mr-0 "}
        >
          <div className={styles.wrapperBadges + " col-12 col-lg-6"}>
            <p className="pl-4 pl-lg-0 pr-lg-10">
              Do you own an <span className={styles.keyWords}>Android</span> device? Download the mobile app from the Play Store by clicking the button below.
            </p>
            <p className={styles.appBadgeParent + " pl-4 pl-lg-0 pr-lg-10"}>
              <OutboundLink target="_blank" href="https://play.google.com/store/apps/details?id=com.engineid.mobile">
                <img src={PlayStoreBadge} className={styles.appBadge} />
              </OutboundLink>
            </p>
          </div>
          <div className={styles.wrapperBadges + " col-12 col-lg-6"}>
            <p className="pl-4 pl-lg-0 pl-lg-10">
              Do you own an <span className={styles.keyWords}>Apple</span> device? Download the mobile app from the App Store by clicking the button below.
            </p>
            <p className={styles.appBadgeParent + " pl-4 pl-lg-0 pr-lg-10"}>
              <OutboundLink target="_blank" href="https://apps.apple.com/us/app/engineid/id1533212495">
                <img src={AppStoreBadge} className={styles.appBadge} />
              </OutboundLink>
            </p>
          </div>
        </WrapperInner>
        <WrapperInner
          className={styles.wrapperInner + " row proxima-nova--light fs-18pt ml-0 mr-0"}
        >
          <div className="col-12 col-lg-6">
            <h2 className="pl-4 pl-lg-0 pr-lg-10">Authenticator</h2>
            <p className="pl-4 pl-lg-0 pr-lg-10">
              A weak username and password makes it very easy for hackers to break into your accounts. 
              If you are concerned with your security on the internet, there are simple solutions available that improve
              your <span className={styles.keyWords}>security posture</span>.
            </p>
            <p className="pl-4 pl-lg-0 pr-lg-10">
              Use your mobile device for <span className={styles.keyWords}>Multi-Factor Authentication</span> (also
              known as <span className={styles.keyWords}>MFA</span>, or <span className={styles.keyWords}>2-Step Verification Codes</span>) 
              to strengthen your login process.
            </p>
            <p className="pl-4 pl-lg-0 pr-lg-10">
              For web applications that support MFA (such as Google Mail), the EngineID app can be used to scan
              a QR code and generate verification codes quickly and easily.
            </p>
          </div>
          <div className="col-12 col-lg-6">
            <h2 className="pl-4 pl-lg-0 pl-lg-10">Passwordless Login</h2>
            <p className="pl-4 pl-lg-0 pl-lg-10">
              EngineID also allows users to login using <span className={styles.keyWords}>Passwordless Login</span>, simply
              click the Passwordless button on the EngineID login page, and a notification
              is sent directly to your mobile. Complete your login from your mobile and
              EngineID logs you in without needing a password at all!
            </p>
            <p className="pl-4 pl-lg-0 pl-lg-10">
              Passwordless Login provides a way to authenticate yourself more securely and without having to enter yet
              another password.
            </p>
          </div>
          <div className="col-12 col-lg-6">
            <h2 className="pl-4 pl-lg-0 pr-lg-10">Secure Backup</h2>
            <p className="pl-4 pl-lg-0 pr-lg-10">
              What makes the EngineID app so good is that you can also <span className={styles.keyWords}>securely backup</span> your 
              authentication codes. If you lose your device, you can restore them on a new device without having to reset all your
              different accounts.
            </p>
          </div>
          <div className="col-12 col-lg-6">
            <h2 className="pl-4 pl-lg-0 pl-lg-10">Messaging</h2>
            <p className="pl-4 pl-lg-0 pl-lg-10">
              EngineID can be used across your team or organization. One of the great features of EngineID is the ability to
              send Push Notification messages directly to the mobile device of other users in your EngineID Organization.
            </p>
            <p className="pl-4 pl-lg-0 pl-lg-10">
              This is perfect for reminders and team updates, but our customers have used this feature for many different uses,
              such as Advanced Authentication. <Link key="mobile-apps-contact" to="/contact-us">Speak with us</Link> to
              learn how we can help you meet your needs.
            </p>
          </div>
        </WrapperInner>
      </Wrapper>
    </section>
  )
}

export default Intro
